import { IClientConfig } from '@front/interfaces/client-config.interface';
import { defaultConfig } from './default.config';

export const ekiConfig: IClientConfig = {
  ...defaultConfig,
  moduleAccess: {
    investment: true,
    modelTypeSwitch: true,
    examples: true,
    gapAnalysis: true,
    displayAvm: false,
    configurationAsClient: true,
    digitalFocus: false,
    effectiveness: true,
    channelPerformance: false,
    scenarios: true
  },
  sso: {
    azure: true
  }
};
